import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function withdrawOperatorFees({
  dst,
  operator,
  operatorFeeDestination,
}: {
  dst: PublicKey;
  operator: PublicKey;
  operatorFeeDestination: PublicKey;
}) {
  const program = makeDSTProgram();
  const result = program.methods.withdrawOperatorFees().accountsPartial({
    operator,
    dst,
    operatorFeeDestination,
  });

  return result;
}
